var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShopify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1886 11.6393C13.1738 11.6393 13.1451 11.6393 13.1303 11.6393C12.884 11.6093 12.6812 11.3836 12.6812 11.1279C12.6664 10.8871 12.5358 5.26072 15.7097 3.98204C16.5069 3.66609 17.2468 3.72623 17.8699 4.19268C18.6374 4.74929 19.1883 5.8625 19.5217 7.48725C19.7531 8.63058 19.7966 9.62342 19.7966 9.6686C19.8115 9.90926 19.6236 10.0899 19.3763 10.0447C19.13 10.0146 18.9273 9.78898 18.9273 9.54823C18.8837 8.52527 18.5504 5.71211 17.4496 4.89969C17.1014 4.64397 16.6662 4.61385 16.1449 4.82449C13.42 5.92264 13.5506 11.2031 13.5506 11.2632C13.5506 11.4739 13.4062 11.6393 13.1886 11.6393Z",
    fill: "#595961"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7096 4.22271C17.13 3.80144 16.4495 3.7413 15.7097 4.02713C14.4199 4.55362 13.507 5.93771 13.058 8.04387C12.7247 9.59331 12.7682 10.9925 12.7682 11.0526C12.7682 11.1278 12.7969 11.2031 12.8552 11.2632C12.9126 11.3234 12.9709 11.3686 13.0431 11.3686C13.058 11.3686 13.0728 11.3686 13.0867 11.3686C13.2172 11.3686 13.3191 11.2632 13.3191 11.1278C13.3191 11.0677 13.1886 5.69696 15.9857 4.56868C16.5504 4.34309 17.043 4.3731 17.4495 4.674C18.6225 5.5315 18.9707 8.43502 19.0142 9.47304C19.0142 9.62343 19.1448 9.77393 19.304 9.78889C19.4494 9.80395 19.5651 9.69863 19.5651 9.54823C19.5503 9.36772 19.391 5.4563 17.7096 4.22271Z",
    fill: "#B2B2C2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.058 11.188C13.0431 11.188 13.0431 11.188 13.0293 11.188C12.9423 11.173 12.869 11.0827 12.8552 10.9924C12.8552 10.9322 12.8117 9.56327 13.145 8.01372C13.5792 5.95275 14.4931 4.58371 15.7532 4.07219C16.4633 3.78635 17.1013 3.84659 17.6522 4.23774C19.2753 5.42616 19.4346 9.27743 19.4346 9.44289C19.4346 9.53315 19.3624 9.59329 19.2753 9.57833C19.1883 9.56327 19.116 9.48807 19.1012 9.38275C19.1012 9.33757 18.942 5.56159 17.4781 4.4784C17.043 4.16254 16.5069 4.11737 15.8986 4.35802C13.058 5.54653 13.1885 10.9924 13.1885 11.0526C13.2024 11.1278 13.145 11.188 13.058 11.188Z",
    fill: "#B2B2C2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2321 6.88555C14.3478 6.65995 14.4635 6.43426 14.5654 6.1936C14.5219 6.2688 14.232 7.05111 13.3478 6.93073C13.333 6.93073 13.8691 7.09618 14.2321 6.88555Z",
    fill: "#595961"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9125 7.84821C13.9996 7.60746 14.0866 7.35174 14.145 7.11108C14.1163 7.20134 13.9709 8.01367 13.0431 8.01367C13.0431 8.01367 13.5792 8.11898 13.9125 7.84821Z",
    fill: "#595961"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9994 5.90771C18.8837 5.63684 18.7531 5.38113 18.6226 5.11035C18.6661 5.20061 19.1013 6.05811 18.6087 6.67486C18.6087 6.67486 18.9856 6.37406 18.9994 5.90771Z",
    fill: "#595961"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2032 4.55376C17.9708 4.35818 17.7393 4.17766 17.5069 4.01221C17.5939 4.08741 18.3624 4.64402 18.3189 5.48656C18.3041 5.48656 18.4347 4.99009 18.2032 4.55376Z",
    fill: "#595961"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6523 6.05792C14.8264 5.8774 14.9708 5.68183 15.13 5.47119C15.0726 5.53133 14.594 6.14818 13.7394 5.92248C13.7394 5.92248 14.2319 6.19335 14.6523 6.05792Z",
    fill: "#595961"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1884 5.36601C15.3911 5.21561 15.5791 5.06512 15.768 4.89966C15.6958 4.94484 15.1014 5.44121 14.2755 5.08017C14.2755 5.08017 14.7532 5.42615 15.1884 5.36601Z",
    fill: "#595961"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9708 4.86936C16.2171 4.79416 16.4495 4.7039 16.681 4.61365C16.594 4.64367 15.8551 4.91444 15.1301 4.34277C15.1449 4.34277 15.5218 4.79416 15.9708 4.86936Z",
    fill: "#595961"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.681 4.59885C16.8837 4.62897 17.0865 4.64403 17.2892 4.65909C17.217 4.64403 16.579 4.59886 16.217 3.99707C16.217 3.99707 16.3625 4.40328 16.681 4.59885Z",
    fill: "#595961"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5217 4.92949C17.6661 5.09505 17.8263 5.26051 17.9994 5.41091C17.9421 5.35077 17.4495 4.8543 17.5653 4.23755C17.5504 4.23755 17.3912 4.58352 17.5217 4.92949Z",
    fill: "#595961"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2753 9.3677C19.2753 9.20214 19.1161 5.39605 17.5365 4.23775C17.2319 4.01206 16.8986 3.90674 16.5504 3.90674C16.2893 3.90674 16.0143 3.96688 15.7245 4.08725C14.4634 4.58372 13.5792 5.92264 13.145 7.96855C12.8117 9.50304 12.8552 10.8721 12.8552 10.9322C12.8552 10.9774 12.8987 11.0225 12.9422 11.0225H12.9561C12.9996 11.0225 13.0293 10.9924 13.0293 10.9473C13.0293 10.8871 12.8839 5.39605 15.7967 4.22269C16.4347 3.96688 16.9856 4.01206 17.4495 4.35803C18.9558 5.45628 19.1161 9.2925 19.1161 9.33758C19.1161 9.38276 19.1596 9.42784 19.2031 9.42784C19.2031 9.42784 19.2031 9.42784 19.2169 9.42784C19.2466 9.4429 19.2753 9.41278 19.2753 9.3677Z",
    fill: "url(#paint0_linear_30_767)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5216 7.48736C19.1883 5.86262 18.6374 4.76436 17.8699 4.19269C17.4495 3.8919 16.9995 3.75646 16.507 3.78658C16.8986 3.8166 17.2606 3.95204 17.594 4.19269C18.3625 4.7494 18.9134 5.86262 19.2467 7.48736C19.4782 8.6307 19.5216 9.62354 19.5216 9.66871C19.5216 9.84923 19.4346 9.98467 19.2892 10.0297C19.3189 10.0448 19.3476 10.0448 19.3624 10.0448C19.6087 10.0749 19.7966 9.90937 19.7828 9.66871C19.7966 9.62354 19.7531 8.64575 19.5216 7.48736Z",
    fill: "url(#paint1_linear_30_767)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8699 4.82453C13.145 5.92269 13.2755 11.2031 13.2755 11.2633C13.2755 11.4438 13.1885 11.5792 13.0431 11.6243C13.0728 11.6394 13.0867 11.6394 13.1163 11.6394C13.1302 11.6394 13.1599 11.6394 13.1737 11.6394C13.3913 11.6394 13.5357 11.4739 13.5357 11.2633C13.5357 11.2031 13.4061 5.93775 16.1301 4.83959C16.319 4.76439 16.493 4.71922 16.6522 4.70416C16.4198 4.65908 16.1597 4.70416 15.8699 4.82453Z",
    fill: "url(#paint2_linear_30_767)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9994 6.13317L7.71012 10.0746C7.71012 10.0746 7.18888 10.2251 7.05832 10.3906C6.92776 10.556 6.89907 11.0224 6.89907 11.0224L5 26.2167L19.2605 28.9848L20.3624 6.11811C20.2031 6.08799 20.0429 6.11811 19.9994 6.13317Z",
    fill: "url(#paint3_linear_30_767)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2465 8.08888C24.2465 8.08888 24.2316 7.9685 24.1594 7.92342C24.1011 7.87825 24.0288 7.87825 24.0288 7.87825L22.0141 7.72785L20.5364 6.20842C20.4781 6.16325 20.4197 6.13322 20.3475 6.11816L19.2467 28.9849L26.9704 27.2548L24.2465 8.08888Z",
    fill: "url(#paint4_linear_30_767)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9273 18.8301C14.7097 18.5293 14.4496 18.2585 14.1885 18.0177C13.9274 17.7771 13.6524 17.5815 13.3765 17.401C13.1886 17.2806 13.0145 17.1602 12.8691 17.0398C12.7247 16.9196 12.6089 16.7992 12.5219 16.6939C12.4349 16.5735 12.3626 16.4682 12.3191 16.3479C12.2756 16.2275 12.2608 16.1071 12.2608 15.9868C12.2608 15.8213 12.3043 15.6559 12.3627 15.5204C12.42 15.3851 12.5219 15.2647 12.6228 15.1594C12.7395 15.0541 12.8691 14.9789 13.0293 14.9187C13.1885 14.8585 13.3764 14.8285 13.5792 14.8134C13.7968 14.7984 14.0144 14.8134 14.2172 14.8285C14.4199 14.8434 14.6088 14.8886 14.7968 14.9337C14.9708 14.9789 15.1449 15.039 15.2893 15.0993C15.4347 15.1594 15.5791 15.2195 15.681 15.2798L16.6375 12.3312C16.4931 12.256 16.319 12.1807 16.1301 12.1356C15.9273 12.0754 15.7097 12.0303 15.4634 12.0002C15.2171 11.9701 14.956 11.9551 14.681 11.9551C14.4061 11.9551 14.1163 11.9701 13.8117 12.0152C13.1599 12.1055 12.5793 12.286 12.058 12.5568C11.5655 12.8126 11.1303 13.1435 10.7683 13.5497C10.4201 13.9409 10.1451 14.3921 9.94236 14.9037C9.75345 15.4001 9.63775 15.9568 9.60907 16.5584C9.59423 16.9196 9.62291 17.2505 9.70994 17.5514C9.78215 17.8523 9.89885 18.1381 10.0581 18.4089C10.2025 18.6797 10.3914 18.9204 10.5942 19.146C10.7969 19.3717 11.0432 19.5823 11.2895 19.7779C11.4922 19.9283 11.6663 20.0787 11.8117 20.2141C11.9561 20.3496 12.0729 20.4849 12.1589 20.6354C12.2459 20.7707 12.3043 20.9062 12.3478 21.0566C12.3913 21.192 12.4062 21.3424 12.3913 21.4929C12.3913 21.6433 12.3478 21.7937 12.2895 21.9141C12.2321 22.0345 12.1589 22.1548 12.0432 22.2451C11.9423 22.3354 11.8118 22.3955 11.6664 22.4256C11.522 22.4556 11.3479 22.4707 11.159 22.4407C10.9424 22.4106 10.7247 22.3504 10.522 22.2601C10.3192 22.1849 10.1155 22.0795 9.92757 21.9742C9.73965 21.869 9.56557 21.7486 9.42018 21.6433C9.26094 21.538 9.13036 21.4176 9.02947 21.3274L8.37665 23.5689C8.47852 23.7193 8.62296 23.8548 8.7822 23.9901C8.94243 24.1256 9.13038 24.2609 9.34798 24.3963C9.56557 24.5167 9.79702 24.637 10.0433 24.7423C10.2896 24.8476 10.5655 24.9379 10.8405 25.0132H10.8553H10.8691H10.884H10.8988C11.4923 25.1485 12.058 25.1786 12.5941 25.1034C13.145 25.0281 13.6524 24.8326 14.0866 24.5318C14.5356 24.2158 14.8986 23.7945 15.1736 23.2379C15.4495 22.6813 15.6088 22.0043 15.6375 21.2371C15.6523 20.7557 15.594 20.3345 15.4634 19.9434C15.3329 19.4921 15.1449 19.146 14.9273 18.8301Z",
    fill: "url(#paint5_linear_30_767)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.226763,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.47063 23.6915C8.43701 23.6516 8.40532 23.6109 8.37664 23.5691L9.02946 21.3275C9.03837 21.3358 9.04825 21.3445 9.05814 21.3533C9.15507 21.44 9.27576 21.5478 9.42017 21.6434C9.56556 21.7487 9.73964 21.8691 9.92756 21.9744C10.1155 22.0796 10.3192 22.185 10.522 22.2603C10.7247 22.3505 10.9424 22.4107 11.159 22.4408C11.3479 22.4708 11.522 22.4558 11.6664 22.4257C11.8118 22.3956 11.9423 22.3355 12.0432 22.2452C12.1589 22.1549 12.2321 22.0346 12.2895 21.9142C12.3478 21.7938 12.3913 21.6434 12.3913 21.493C12.4062 21.3425 12.3913 21.1921 12.3478 21.0567C12.3043 20.9063 12.2459 20.7709 12.1589 20.6355C12.0768 20.4925 11.968 20.3632 11.8325 20.2344C11.9037 20.3148 11.9641 20.3974 12.0145 20.485C12.1015 20.6205 12.1589 20.7558 12.2024 20.9063C12.2459 21.0416 12.2608 21.1921 12.246 21.3425C12.246 21.493 12.2024 21.6434 12.1451 21.7638C12.0867 21.8842 12.0145 22.0044 11.8988 22.0947C11.7969 22.185 11.6664 22.2452 11.522 22.2752C11.3766 22.3053 11.2025 22.3204 11.0146 22.2903C10.797 22.2603 10.5793 22.2 10.3766 22.1098C10.1738 22.0346 9.97105 21.9292 9.78214 21.8239C9.59421 21.7186 9.42017 21.5983 9.27577 21.493C9.13037 21.3974 9.0097 21.2896 8.91277 21.203C8.90288 21.1941 8.89393 21.1854 8.88404 21.1771L8.23224 23.4186C8.29653 23.5143 8.37865 23.604 8.47063 23.6915ZM10.606 19.1598C10.5516 19.1059 10.4992 19.0513 10.4488 18.9957C10.246 18.77 10.0581 18.5294 9.91271 18.2586C9.75347 17.9877 9.63774 17.7019 9.56554 17.4011C9.4785 17.1002 9.4488 16.7692 9.46363 16.4081C9.49232 15.8064 9.60906 15.2498 9.79699 14.7533C9.99975 14.2419 10.2757 13.7906 10.6229 13.3994C10.9859 12.9932 11.42 12.6622 11.9126 12.4065C12.4348 12.1357 13.0144 11.9552 13.6662 11.8649C13.9709 11.8197 14.2607 11.8047 14.5357 11.8047C14.8116 11.8047 15.0727 11.8197 15.319 11.8499C15.5653 11.88 15.7829 11.9251 15.9857 11.9853C16.1736 12.0304 16.3477 12.1056 16.4931 12.1808L16.4703 12.2512C16.3655 12.2056 16.2507 12.1645 16.1301 12.1357C15.9273 12.0756 15.7097 12.0304 15.4634 12.0003C15.2171 11.9702 14.956 11.9552 14.681 11.9552C14.4061 11.9552 14.1163 11.9702 13.8117 12.0153C13.1599 12.1056 12.5793 12.2861 12.058 12.557C11.5655 12.8127 11.1303 13.1436 10.7683 13.5498C10.4201 13.941 10.1451 14.3922 9.94236 14.9038C9.75344 15.4002 9.63774 15.9569 9.60906 16.5585C9.59423 16.9197 9.6229 17.2506 9.70994 17.5515C9.78214 17.8524 9.89884 18.1382 10.0581 18.409C10.2025 18.6798 10.3914 18.9205 10.5942 19.1461C10.5981 19.1506 10.6021 19.1553 10.606 19.1598ZM12.5743 16.7556C12.6534 16.8451 12.7524 16.9425 12.8691 17.04C13.0145 17.1603 13.1885 17.2807 13.3765 17.4011C13.6524 17.5816 13.9274 17.7772 14.1885 18.0178C14.2646 18.0879 14.3398 18.1605 14.415 18.2357C14.2943 18.1059 14.1687 17.9832 14.0431 17.8674C13.7829 17.6267 13.507 17.4311 13.2321 17.2506C13.0432 17.1302 12.8691 17.0099 12.7247 16.8896C12.6703 16.8447 12.6208 16.7998 12.5743 16.7556Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5066 24.7276L22.0141 7.72792L21.927 7.63767L22.1595 24.4868C22.1595 24.4868 20.116 27.7062 19.8114 27.6159C19.3623 27.4806 20.6956 6.37396 20.6956 6.37396L20.5502 6.22356C20.4929 6.17838 20.4197 6.14836 20.3623 6.1333L19.2753 28.6841L19.2605 29L19.6373 28.5035L22.5066 24.7276Z",
    fill: "url(#paint6_linear_30_767)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9559 7.11119C16.7828 7.8182 16.5652 8.48013 16.406 8.88634C16.3041 9.12709 16.4199 9.35269 16.6375 9.38281C16.8699 9.41292 17.13 9.24737 17.2171 9.00671C17.2319 8.96154 17.6225 7.98375 17.8698 6.82536V6.8103L16.9559 7.11119Z",
    fill: "url(#paint7_linear_30_767)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4202 9.21717C10.2174 9.66846 10.0146 10.0596 9.86925 10.3304C9.73968 10.5561 9.81187 10.7967 10.0295 10.8569C10.2461 10.9322 10.5359 10.7967 10.6664 10.571C10.6813 10.541 11.1017 9.80389 11.4785 8.87109L10.4202 9.21717Z",
    fill: "url(#paint8_linear_30_767)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2605 28.9848L22.5066 24.7273L27 27.2547L19.2605 28.9848Z",
    fill: "url(#paint9_linear_30_767)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2605 28.9848L22.4779 24.7273L27 27.2547L19.2605 28.9848Z",
    fill: "url(#paint10_linear_30_767)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2605 28.9848L22.4779 24.7273L27 27.2547L19.2605 28.9848Z",
    fill: "url(#paint11_linear_30_767)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1014 17.0702C17.7828 19.432 18.9133 21.9895 19.478 24.4717L20.3623 6.10318C20.2031 6.07316 20.0428 6.10318 19.9993 6.11824L7.71007 10.0748C7.71007 10.0748 7.59431 10.1048 7.44891 10.1651C10.5655 11.2783 13.6811 13.6703 16.1014 17.0702Z",
    fill: "url(#paint12_linear_30_767)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1731 7.93849C24.2463 7.99872 24.2463 8.08898 24.2463 8.08898L26.9415 27.2397L22.5065 24.7124L22.014 7.71289L24 7.86329C24.0139 7.87835 24.1009 7.87835 24.1731 7.93849Z",
    fill: "url(#paint13_linear_30_767)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8548 7.98382C23.8548 7.98382 23.9419 7.98382 24.0141 8.05902C24.0863 8.11926 24.101 8.20951 24.101 8.20951L26.7538 27.1497L26.9565 27.2701L24.2603 8.1042C24.2603 8.1042 24.2465 8.01394 24.1881 7.9538C24.1159 7.89356 24.0141 7.89356 24.0141 7.89356L22.029 7.74316L23.8548 7.98382Z",
    fill: "url(#paint14_linear_30_767)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 26.2165L19.2605 28.9846L19.9568 13.3088L6.77338 13.6836L5 26.2165Z",
    fill: "url(#paint15_linear_30_767)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.68123 10.2938C9.55167 10.6595 9.67923 11.0436 9.96804 11.1521C10.2559 11.2605 10.5941 11.052 10.7247 10.6865C10.8543 10.3209 10.7257 9.93663 10.4379 9.82826C10.1501 9.71979 9.8108 9.92826 9.68123 10.2938Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.89,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66552 10.1203C9.53595 10.4859 9.66451 10.8702 9.95233 10.9785C10.2401 11.087 10.5794 10.8785 10.709 10.513C10.8386 10.1473 10.711 9.76304 10.4222 9.65467C10.1344 9.54621 9.79608 9.75468 9.66552 10.1203Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0289 7.72785L20.5502 6.20842C20.4929 6.16325 20.4197 6.13322 20.3623 6.11816L19.2605 28.9849L22.5214 24.7123L22.0289 7.72785Z",
    fill: "url(#paint16_linear_30_767)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9994 6.13348L7.71014 10.0749C7.71014 10.0749 7.1889 10.2254 7.05834 10.3909C7.0435 10.4059 7.04345 10.421 7.0296 10.436L19.4198 6.88566C19.5217 6.85554 19.7679 6.76529 19.7393 7.50241L18.9856 28.955L19.2467 29.0002L20.3475 6.13348C20.2031 6.0883 20.0429 6.11842 19.9994 6.13348Z",
    fill: "url(#paint17_linear_30_767)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9994 6.13348L7.71014 10.0749C7.71014 10.0749 7.1889 10.2254 7.05834 10.3909C7.0435 10.4059 7.04345 10.421 7.0296 10.436L9.89891 9.60857L19.7679 6.43437C19.8115 6.41931 19.9707 6.3892 20.13 6.41932L19.043 28.955L19.2467 29.0002L20.3475 6.13348C20.2031 6.0883 20.0429 6.11842 19.9994 6.13348Z",
    fill: "url(#paint18_linear_30_767)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1595 25.0885L22.5067 24.7124L19.2467 28.9849L19.4198 28.9397C19.4198 28.9397 22.2901 25.1036 22.5502 24.9832C22.7391 24.908 23.1595 25.0885 23.1595 25.0885Z",
    fill: "url(#paint19_linear_30_767)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2605 28.9849L22.5214 24.7124C22.5066 24.7275 20.4493 27.0592 19.2605 28.9849Z",
    fill: "url(#paint20_linear_30_767)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9999 27.2547L22.5214 24.7273C22.5066 24.7273 23.0288 24.8176 26.9999 27.2547Z",
    fill: "url(#paint21_linear_30_767)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3071 8.79379C16.1765 9.15944 16.3051 9.54371 16.5929 9.65217C16.8818 9.76064 17.22 9.55217 17.3496 9.18661C17.4802 8.82095 17.3516 8.43669 17.0638 8.32822C16.7759 8.21985 16.4367 8.42823 16.3071 8.79379Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.89,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2913 8.62097C16.1617 8.98663 16.2904 9.37089 16.5782 9.47935C16.866 9.58772 17.2052 9.37935 17.3348 9.01369C17.4643 8.64813 17.3367 8.26388 17.0489 8.15541C16.7601 8.04694 16.4219 8.25541 16.2913 8.62097Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1887 10.8571C10.1739 10.8571 10.1452 10.8571 10.1303 10.8571C9.89888 10.8271 9.73967 10.6014 9.76835 10.3457C9.79704 10.1049 10.6229 4.47849 14.0144 3.19982C14.869 2.88386 15.594 2.944 16.1449 3.41045C16.8115 3.96706 17.1735 5.08028 17.2319 6.70502C17.2754 7.84836 17.1449 8.8412 17.1449 8.88638C17.1162 9.12703 16.8986 9.30764 16.6662 9.26247C16.4347 9.23235 16.2606 9.00675 16.3041 8.766C16.4347 7.74304 16.5791 4.92988 15.6088 4.11746C15.3042 3.86174 14.8839 3.83162 14.3191 4.04226C11.4063 5.14042 10.6377 10.4209 10.6377 10.4659C10.5794 10.6916 10.4063 10.8571 10.1887 10.8571Z",
    fill: "#595961"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9708 3.44039C15.4634 3.01922 14.7968 2.95908 13.9996 3.24491C12.6228 3.7714 11.4636 5.15539 10.6664 7.24649C10.0729 8.79603 9.8692 10.1951 9.8692 10.2553C9.85535 10.3305 9.88406 10.4057 9.92758 10.466C9.9711 10.5261 10.0294 10.5713 10.1016 10.5713C10.1155 10.5713 10.1303 10.5713 10.1451 10.5713C10.2757 10.5713 10.3914 10.466 10.4062 10.3305C10.4201 10.2704 11.1886 4.89968 14.1885 3.7714C14.7968 3.54571 15.2893 3.57583 15.6375 3.87672C16.6661 4.73422 16.5217 7.63764 16.3912 8.67566C16.3763 8.82615 16.4782 8.97655 16.6226 8.99161C16.768 9.00667 16.9124 8.90135 16.9272 8.75095C16.9421 8.5854 17.4495 4.67408 15.9708 3.44039Z",
    fill: "#B2B2C2"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1304 10.4058C10.1155 10.4058 10.1155 10.4058 10.1017 10.4058C10.0147 10.3907 9.95628 10.3005 9.97111 10.2102C9.98595 10.15 10.1739 8.78104 10.7683 7.23149C11.5655 5.17052 12.696 3.80149 14.0431 3.28996C14.8117 3.00413 15.4348 3.06436 15.9125 3.45552C17.3328 4.64393 16.8403 8.49521 16.8116 8.66066C16.7967 8.75092 16.7246 8.81106 16.6227 8.7961C16.5366 8.78104 16.4783 8.70584 16.4783 8.60052C16.4783 8.55535 16.9708 4.77937 15.6959 3.69617C15.3191 3.41034 14.7969 3.38032 14.1599 3.62097C11.1017 4.77937 10.3045 10.2102 10.3045 10.2703C10.2896 10.3455 10.2174 10.4058 10.1304 10.4058Z",
    fill: "#B2B2C2"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0432 6.10308C12.2024 5.87748 12.3478 5.65179 12.4922 5.41113C12.4348 5.48633 12.0145 6.26864 11.1451 6.14826C11.1303 6.14826 11.6377 6.31371 12.0432 6.10308Z",
    fill: "#595961"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5507 7.06574C11.6813 6.82499 11.8118 6.56927 11.9127 6.32861C11.8692 6.41887 11.5794 7.23119 10.6664 7.23119C10.6664 7.23119 11.1739 7.33651 11.5507 7.06574Z",
    fill: "#595961"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1738 8.05899C11.2895 7.80318 11.3766 7.54746 11.4636 7.29175C11.4201 7.38201 11.2609 8.20939 10.3044 8.31471C10.3044 8.29965 10.8257 8.35988 11.1738 8.05899Z",
    fill: "#595961"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9707 5.12524C16.8985 4.85437 16.8263 4.59866 16.7244 4.32788C16.7531 4.41814 17.0429 5.27564 16.4495 5.89239C16.4495 5.89239 16.8836 5.59159 16.9707 5.12524Z",
    fill: "#595961"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4061 3.77128C16.2033 3.57571 15.9995 3.39519 15.7968 3.22974C15.8699 3.30494 16.5505 3.86154 16.3625 4.70398C16.3477 4.70398 16.5653 4.20751 16.4061 3.77128Z",
    fill: "#595961"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1161 6.50936C17.1013 6.23859 17.0578 5.95276 17.0143 5.68188C17.0143 5.7872 17.1597 6.67482 16.4634 7.15623C16.4634 7.15623 16.9421 6.9456 17.1161 6.50936Z",
    fill: "#595961"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1884 7.92357C17.2032 7.6528 17.2032 7.36697 17.1884 7.09619C17.1884 7.20151 17.2032 8.08913 16.4634 8.49524C16.4634 8.48028 16.9708 8.32978 17.1884 7.92357Z",
    fill: "#595961"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8404 9.15698C10.9274 8.88621 10.9858 8.61543 11.0432 8.35962C11.0145 8.44988 10.8839 9.30738 9.99969 9.51801C10.0145 9.51801 10.5357 9.50296 10.8404 9.15698Z",
    fill: "#595961"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5941 5.27545C12.7969 5.09493 12.9858 4.89936 13.1599 4.68872C13.0867 4.74886 12.5071 5.36571 11.696 5.14001C11.7099 5.14001 12.159 5.41088 12.5941 5.27545Z",
    fill: "#595961"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2458 4.58378C13.4783 4.43338 13.6959 4.28289 13.9125 4.11743C13.8264 4.16261 13.1598 4.65898 12.3913 4.29795C12.3913 4.29795 12.7968 4.64392 13.2458 4.58378Z",
    fill: "#595961"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1301 4.08738C14.3912 4.01208 14.6375 3.92182 14.8838 3.83157C14.7968 3.86168 14.0144 4.13246 13.3765 3.56079C13.3765 3.56079 13.6811 4.01208 14.1301 4.08738Z",
    fill: "#595961"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.869 3.81663C15.0727 3.84675 15.2755 3.86181 15.4783 3.87687C15.4061 3.86181 14.7829 3.81663 14.507 3.21484C14.5218 3.21484 14.594 3.62105 14.869 3.81663Z",
    fill: "#595961"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6523 4.14737C15.7829 4.31282 15.9124 4.47828 16.043 4.62878C15.9995 4.56854 15.5939 4.07217 15.7967 3.45532C15.8115 3.45532 15.5939 3.80139 15.6523 4.14737Z",
    fill: "#595961"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6522 8.58537C16.666 8.41992 17.1596 4.61382 15.7828 3.45543C15.5217 3.22983 15.2032 3.12451 14.8551 3.12451C14.594 3.12451 14.3042 3.18465 13.9995 3.30503C12.6663 3.8015 11.5506 5.14041 10.7682 7.18633C10.1738 8.72081 9.98581 10.0898 9.97098 10.15C9.97098 10.1951 9.99972 10.2402 10.0432 10.2402H10.058C10.1015 10.2402 10.1302 10.2101 10.1302 10.165C10.1451 10.1048 10.9274 4.61382 14.043 3.44037C14.7096 3.18465 15.2754 3.22983 15.6809 3.5758C16.9994 4.67396 16.5068 8.51018 16.493 8.55536C16.493 8.60044 16.5217 8.64562 16.5652 8.64562C16.5652 8.64562 16.5652 8.64562 16.579 8.64562C16.6225 8.66067 16.6522 8.63055 16.6522 8.58537Z",
    fill: "url(#paint22_linear_30_767)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2319 6.70489C17.1735 5.08014 16.8115 3.98189 16.1449 3.41022C15.7829 3.10943 15.3477 2.97399 14.8552 3.00411C15.232 3.03413 15.5792 3.16957 15.87 3.41022C16.5366 3.96693 16.8986 5.08014 16.9559 6.70489C16.9994 7.84822 16.8699 8.84107 16.8699 8.88624C16.8402 9.06676 16.7245 9.2022 16.5791 9.24727C16.6088 9.26233 16.6226 9.26234 16.6523 9.26234C16.8837 9.29245 17.1013 9.1269 17.13 8.88624C17.1449 8.84107 17.2754 7.86328 17.2319 6.70489Z",
    fill: "url(#paint23_linear_30_767)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0293 4.04213C11.1165 5.14029 10.348 10.4207 10.348 10.4809C10.3193 10.6614 10.2026 10.7968 10.0582 10.8419C10.0868 10.857 10.1017 10.857 10.1304 10.857C10.1452 10.857 10.1739 10.857 10.1887 10.857C10.4063 10.857 10.5794 10.6915 10.6091 10.4809C10.6229 10.4207 11.3766 5.15535 14.2894 4.0571C14.4932 3.9819 14.6663 3.93682 14.8265 3.92176C14.609 3.89164 14.333 3.93682 14.0293 4.04213Z",
    fill: "url(#paint24_linear_30_767)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_30_767",
    x1: 13.6109,
    y1: 3.9407,
    x2: 13.1563,
    y2: 10.1289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_30_767",
    x1: 16.9323,
    y1: 7.48283,
    x2: 20.1323,
    y2: 10.2856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_30_767",
    x1: 15.6493,
    y1: 10.7252,
    x2: 19.0364,
    y2: 7.57029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_30_767",
    x1: 11.338,
    y1: 1.51839,
    x2: -1.81782,
    y2: 16.6768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8D26E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FB525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_30_767",
    x1: 29.3342,
    y1: 5.31342,
    x2: 22.114,
    y2: 5.44749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4E034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60A927"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_30_767",
    x1: 7.85837,
    y1: 15.421,
    x2: 1.93878,
    y2: 29.8364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CECEEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_30_767",
    x1: 16.3457,
    y1: 50.9217,
    x2: 25.7211,
    y2: 50.9027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.038033,
    stopColor: "#1D1D1B",
    stopOpacity: 0.4837
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4243,
    stopColor: "#1D1D1B",
    stopOpacity: 0.3185
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_30_767",
    x1: 17.4346,
    y1: 5.80063,
    x2: 15.8792,
    y2: 6.63774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_30_767",
    x1: 10.9137,
    y1: 8.28338,
    x2: 9.82036,
    y2: 9.22302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_30_767",
    x1: 21.5789,
    y1: 27.2659,
    x2: 21.6896,
    y2: 28.7251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_30_767",
    x1: 18.9944,
    y1: 25.1298,
    x2: 19.251,
    y2: 28.9235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0896271,
    stopColor: "white",
    stopOpacity: 0.4552
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_30_767",
    x1: 18.5009,
    y1: 25.7198,
    x2: 18.9574,
    y2: 29.7724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_30_767",
    x1: 16.7097,
    y1: 2.40387,
    x2: 5.00175,
    y2: 9.17526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_30_767",
    x1: 18.9686,
    y1: 37.7935,
    x2: 29.3025,
    y2: 37.8143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0896271,
    stopColor: "#1D1D1B",
    stopOpacity: 0.4552
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_30_767",
    x1: 26.369,
    y1: 7.17307,
    x2: 24.9011,
    y2: 7.53276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_30_767",
    x1: 13.1985,
    y1: 29.152,
    x2: 13.9618,
    y2: 25.4719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0896271,
    stopColor: "#1D1D1B",
    stopOpacity: 0.4552
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_30_767",
    x1: 17.6117,
    y1: 50.4532,
    x2: 27.0208,
    y2: 50.4614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_30_767",
    x1: 9.01369,
    y1: 4.80776,
    x2: 4.45032,
    y2: 22.3401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_30_767",
    x1: 9.01369,
    y1: 4.80776,
    x2: 4.45032,
    y2: 22.3401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_30_767",
    x1: 20.0884,
    y1: 23.1862,
    x2: 16.4815,
    y2: 28.1507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0896271,
    stopColor: "white",
    stopOpacity: 0.4552
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_30_767",
    x1: 21.1763,
    y1: 24.3276,
    x2: 20.8192,
    y2: 25.1281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_30_767",
    x1: 24.7181,
    y1: 25.386,
    x2: 24.7005,
    y2: 25.6011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_30_767",
    x1: 11.7296,
    y1: 2.6181,
    x2: 10.1703,
    y2: 8.77808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_30_767",
    x1: 15.2191,
    y1: 6.17151,
    x2: 17.9316,
    y2: 8.92921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_30_767",
    x1: 13.4853,
    y1: 10.2325,
    x2: 17.233,
    y2: 6.38367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopify);
export default __webpack_public_path__ + "static/media/shopify.cbb35a8c163e4a4ac1a03a74bc4e68e3.svg";
export { ForwardRef as ReactComponent };